module.exports = __webpack_public_path__ + "img/Best Sellers Ranking_old.4045f20d.svg";